export const OPERATIONAL_MEDICINE = 'operational';
export const FLIGHT_MEDICINE = 'flight';
export const PRIMARY_ROSTER = 'primary';
export const SECONDARY_ROSTER = 'secondary';
export const ALTERNATE_ROSTER = 'alternate';
export const MEDICAL_SERVICE = 'MEDICAL_SERVICE';
export const PRIMARY_ROSTER_MED_SERVICE = 1;
export const SECONDARY_ROSTER_MED_SERVICE = 2;
export const ALTERNATE_ROSTER_MED_SERVICE = 3;
